import authentication from "@irati/auth"
import env from "@irati/utils/env"
import environment from "@irati/utils/constants/environment"

// Docs: "/docs/web/devToggles.md"
class DevToggles {
  /**
   * @description: Rolling out VR experience for Wellness (WEL-1763)
   */
  showWellnessVRExample() {
    const allowedDomainsForTesting = ["qa-business", "test-staging-business", "test-prod-business"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showHomePageFestiveCard() {
    const allowedDomainsForTesting = ["kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn", "festive"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showUnreadIndicator() {
    const allowedDomainsForTesting = ["group-recognition", "kimbo", "apple", "guild", "zenitechteam", "codethread", "recognitionn"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showSSOFeatureFlag() {
    const allowedDomainsForTesting = [
      "home",
      "testaccount1",
      "testaccount2",
      "testaccount3",
      "testaccount4",
      "testaccount5",
      "testaccount6",
      "testaccount12",
      "abcdefg",
      "test-account-self-renewal-training",
      "test-account-upsell",
      "test-account-renew-integ-w-disc"
    ]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  useCheckoutCom() {
    return env.GRAPH_QL === "v2"
  }

  showSendingTeamsSetting() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "flavio"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showRecommendedBrandsSlider() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "raultenant", "home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  isSSOfromVivup() {
    const allowedDomainsForTesting = ["raultenant", "andradasso"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showPayrollPayBenefits() {
    const allowedDomainsForTesting = ["guild", "apple"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showTopRedeemedPerksCategory() {
    const allowedDomainsForTesting = ["home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showPayrollPayNewFlow() {
    const allowedDomainsForTesting = ["guild", "apple", "kimbo", "cyber"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showNewWellness() {
    if (this.businessIs(["codethread"])) return false // off to test staging flag

    // prettier-ignore
    if (this.userIs([ // prod test users
      "e7c4c0a9-36f7-46e5-8a9f-d43c3822ff11", "a06fff98-ad13-45d6-b980-ded2ebed29a9", "96d153aa-8794-4b57-a700-d1982dbb6083", "08028a89-1f95-48cc-bcac-2af048905ec3",
      "5ae109d7-44c3-4880-b525-99359112b114", "12b0770a-e699-4e73-b91b-7878b57841c3", "547ea292-7a1e-48c1-97de-e1915c93ea1a", "8bfcaf3b-a7ff-4367-b9a8-0ca54ebbb185",
      "5be9e8a4-260e-40c4-9146-ac0a88f7ac37", "a2898d96-a7b5-4670-9311-540ff60e1232", "6233a557-dd56-461e-91ae-6b07922d570e"
    ])) return true

    return this.isProductionGuild() || this.isNotProduction()
  }

  showFriendsAndFamily() {
    const allowedDomainsForTesting = ["guild", "flavio", "zenitechteam", "group-recognition", "braze-test-tenant"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showBudgetBulk() {
    const allowedDomainsForTesting = ["guild", "flavio", "zenitechteam"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showBudgetBulk() {
    const allowedDomainsForTesting = ["guild", "flavio", "zenitechteam"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  private isProduction() {
    return env.ENVIRONMENT_NAME === environment.PRODUCTION
  }

  private isNotProduction() {
    return !this.isProduction()
  }

  private isProductionGuild() {
    return this.isProduction() && this.businessIs(["guild"])
  }

  private businessIs(domains: string[]) {
    return authentication.isLoggedIn() && domains.includes(authentication.business().subdomain)
  }

  private userIs(users: string[]) {
    return authentication.isLoggedIn() && users.includes(authentication.user().uuid ?? "nope")
  }
}

export default new DevToggles()
